import Validator from 'validatorjs';

const validatorName = 'multiKeyNameMatch';
Validator.register(
  validatorName,
  function multiKeyNameMatch(value) {
    if (value) {
      const { tokens } = this.validator.input;
      if (tokens.filter((token) => token.key === value).length > 1) {
        return false;
      }
    }
    return true;
  },
  'Cannot have multiple keys with the same name.'
);

export default validatorName;
